<template>
  <div class="list-fen">
    <div class="section" v-if="!isCreate">
      <div class="aside">
        <div class="table-top-btns">
          <div class="left-btn">
          </div>
          <div class="right-btn">
            <el-button @click="addDialogFun({}, 1)" class="search el-icon-plus"
              >新建任务</el-button
            >
          </div>
        </div>
        <common-table
          :select="true"
          :page="page"
          :dataList="dataList"
          :selectedIdOptions="selectedIdOptions"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          @handleSelectionChange="handleSelectionChange"
        >
          <template v-slot:state="{ scope }">
            <el-switch
              @change="
                value => {
                  changeStateIndexFun(value, scope.row.id);
                }
              "
              v-model="scope.row.state"
              active-value="是"
              inactive-value="否"
              active-color="#0495FF"
            >
            </el-switch>
          </template>
          <template v-slot:operation="{ scope }">
            <el-button
              @click="addDialogFun(scope.row, 1)"
              style="color: #0090FF;font-size: 16px;"
              type="text"
              >编辑</el-button
            >
            <el-button
              @click="delIndexFun(scope.row.id)"
              style="color: #EB3538;font-size: 16px;"
              type="text"
              >删除</el-button
            >
          </template>
        </common-table>
      </div>
    </div>
    <create @back="back" class="section" :typeTask="1" v-else></create>
  </div>
</template>
<script>
import {
  indexPage,
  selList,
  copyIndex,
  delIndex,
  changeStateIndex,
  delBatchIndex
} from "@/api/base.js";
// import addDialog from "./components/addDialog.vue";
import commonTable from "@/components/table/index.vue";
import pageChangeSelect from "@/mixins/page-change-select.js";
import create from "./create.vue";
export default {
  components: {
    // addDialog,
    commonTable,
    create
  },
  mixins: [pageChangeSelect],
  data() {
    return {
      form: {
        ghEventTypeId: "",
        sxmc: "",
        sfyjsx: "",
        zbmc: "",
        khdx: "",
        state: ""
      },
      sfyjsxOptions: [
        {
          label: "是",
          value: "是"
        },
        {
          label: "否",
          value: "否"
        }
      ],
      dialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [{
          ghEventManageSxmc: '事项名称'
        }],
        columns: [
          {
            prop: "ghEventManageSxmc",
            label: "事项名称"
          },
          {
            prop: "zbmc",
            label: "任务开始时间"
          },
          {
            prop: "fzqz",
            label: "任务创建人"
          },
          {
            prop: "khdx",
            label: "任务状态"
          },
          {
            slot: "state",
            label: "任务启停"
          },
          {
            slot: "operation",
            label: "操作"
          }
        ]
      },
      curItem: {},
      typeList: [],
      isCreate: false
    };
  },
  mounted() {
  },
  methods: {
    openDialog(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    addDialogFun(item, type) {
      this.isCreate = true;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.indexPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.indexPageFun();
    },
    async delIndexFun(id) {
      const res = await delIndex({
        id: id
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.indexPageFun();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async changeStateIndexFun(value, id) {
      const res = await changeStateIndex({
        id: id,
        state: value
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.indexPageFun();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 分页查询
    async indexPageFun() {
      let params = {
        ghEventTypeId: this.form.ghEventTypeId,
        sxmc: this.form.sxmc,
        sfyjsx: this.form.sfyjsx,
        zbmc: this.form.zbmc,
        khdx: this.form.khdx,
        state: this.form.state,
        page: this.page.page,
        size: this.page.size
      };
      const res = await indexPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    },
    back() {
      this.isCreate = false;
    },
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.list-fen{
  .section {
    height: calc(100vh - 180px);
    .block {
      right: 10px;
    }
  }
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/customTask/components/oneTimeTask.vue